import { render, staticRenderFns } from "./OutputSettings.vue?vue&type=template&id=212bc94a&"
import script from "./OutputSettings.vue?vue&type=script&lang=js&"
export * from "./OutputSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports